export default "e47ac1e63b5a2d6b.svg"